require('./_Fixed/Video_Fixed.scss');

const b = require('app/www/libs/b')('video', true);

const _ = {
    throttle: require('lodash/throttle'),
    isEmpty: require('lodash/isEmpty'),
};

const React = require('react');
const PropTypes = require('prop-types');

const Metrika = require('app/www/libs/client/metrika');

const {withI18n} = require('app/www/components/contexts/I18n');

const SCROLL_TIMEOUT = 200;
const START_VIDEO = 'started';

class Video extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            stopped: false,
            fixed: false,
            videoStarted: false,
        };

        this._videoStarted = false;
        this._videoState = {};

        this._onClose = this._onClose.bind(this);
        this._onScroll = _.throttle(this._onScroll.bind(this), SCROLL_TIMEOUT);
        this._onMouseLeave = this._onMouseLeave.bind(this);
        this._onMouseEnter = this._onMouseEnter.bind(this);
        this._onPostMessage = this._onPostMessage.bind(this);
        this._onPostMessageTrailer = this._onPostMessageTrailer.bind(this);
    }

    componentDidMount() {
        if (window.addEventListener) {
            window.addEventListener('message', this._onPostMessage);

            if (this.props.hasFixedVersion) {
                this._onScroll();
                window.addEventListener('scroll', this._onScroll);
            }
        }
    }

    componentWillUnmount() {
        if (window.removeEventListener) {
            window.removeEventListener('message', this._onPostMessage);
            if (this.props.hasFixedVersion) {
                window.removeEventListener('scroll', this._onScroll);
            }
        }
    }

    render() {
        const {
            i18n,
            title,
            className,
            isTouchButtons,
            hasFixedVersion,
        } = this.props;

        const {
            fixed,
            hover,
            stopped,
        } = this.state;

        const props = this.props;
        const iFrameProps = Object.assign({}, props);

        delete iFrameProps.i18n;
        delete iFrameProps.metrika;
        delete iFrameProps.isTrailer;
        delete iFrameProps.postMessageHandler;
        delete iFrameProps.hasFixedVersion;

        if (hasFixedVersion) {
            iFrameProps.src = !stopped
                ? iFrameProps.src
                : `${iFrameProps.src}&autoplay=0`;
        }

        const mods = Object.assign({}, {
            fixed: hasFixedVersion && fixed && !isTouchButtons,
        }, props.mods);

        return (
            <div
                className={b(mods)}
                ref={ref => (this._node = ref)}
            >
                <div className={b('player', {hover})}
                    onMouseEnter={this._onMouseEnter}
                    onMouseLeave={this._onMouseLeave}
                >
                    {hasFixedVersion && (
                        <div className={b('close')} onClick={this._onClose} title={i18n.get('channel-player.close')}/>
                    )}
                    <div className={b('play-control')} />
                    {fixed && title && (
                        <div className={b('title')}>
                            {title}
                        </div>
                    )}
                    <iframe
                        className={b.mix(className, mods)}
                        {...iFrameProps}
                    />
                </div>
            </div>
        );
    }

    /**
     * @returns {Object}
     */
    get node() {
        return this._node;
    }

    /**
     * Вызываемый при каждом postMessage-событии, пришедшем от плеера
     * @param {Object} evt
     * @private
     */
    _onPostMessage(evt) {
        const {data} = evt;
        const {
            metrika,
            isTrailer,
            postMessageHandler,
        } = this.props;


        if (data && data.event === START_VIDEO) {
            this.setState({
                videoStarted: true,
            });
        }

        if (metrika && data._source === 'ya.videoiframe') {
            if (!this._videoStarted) {
                Metrika.reachGoal(`${metrika.name}_START`, metrika.prefix);
                this._videoStarted = true;
            }

            switch (data.action) {
                case 'status':
                    if (data.progress >= 50 && !this._videoState.videoFifthyPercentLeft) {
                        Metrika.reachGoal(`${metrika.name}_50`, metrika.prefix);
                        this._videoState.videoFifthyPercentLeft = true;
                    } else if (data.progress >= 90 && !this._videoState.videoNinetyPercentLeft) {
                        Metrika.reachGoal(`${metrika.name}_90`, metrika.prefix);
                        this._videoState.videoNinetyPercentLeft = true;
                    }
                    break;

                case 'adStateChange':
                    if (data.state === 'play') {
                        Metrika.reachGoal(`${metrika.name}_AD_START`, metrika.prefix);
                    } else if (data.state === 'end') {
                        Metrika.reachGoal(`${metrika.name}_AD_DONE`, metrika.prefix);
                    }
                    break;
            }
        }

        if (isTrailer) {
            this._onPostMessageTrailer(data);
        }

        postMessageHandler(data);
    }

    _onScroll() {
        if (this._node) {
            this.setState({
                fixed: this.state.videoStarted && this._node.getBoundingClientRect().bottom <= 0,
            });
        }
    }

    /**
     * @private
     */
    _onClose() {
        const {onClose} = this.props;

        this.setState({
            stopped: true,
            fixed: false,
            videoStarted: false,
        });

        onClose();
    }

    /**
     * @private
     */
    _onMouseEnter() {
        this.setState({
            hover: true,
        });
    }

    /**
     * @private
     */
    _onMouseLeave() {
        this.setState({
            hover: false,
        });
    }

    /**
     * @param {Object} data
     * @private
     */
    _onPostMessageTrailer(data) {
        const {metrika} = this.props;

        if (data._source !== 'ya.videoiframe') {
            return;
        }

        if (
            !this._start &&
            !_.isEmpty(metrika) &&
            !_.isEmpty(metrika.programType)
        ) {
            const idToType = {
                2: 'INFO',
                3: 'CHILDREN',
                4: 'SERIES',
                5: 'FILMS',
                7: 'SPORT',
            };

            if (idToType[metrika.programType.id]) {
                const typeName = `TRAILER_${ idToType[metrika.programType.id] }_START`;
                Metrika.reachGoal(typeName);
            }

            this._start = true;
        }

        this.videoState = this.videoState || {};

        switch (data.action) {
            case 'status':
                if (data.progress >= 50 && !this.videoState.trailerFifthyPercentLeft) {
                    Metrika.reachGoal('TRAILER_50');
                    this.videoState.trailerFifthyPercentLeft = true;
                } else if (data.progress >= 90 && !this.videoState.trailerNinetyPercentLeft) {
                    Metrika.reachGoal('TRAILER_90');
                    this.videoState.trailerNinetyPercentLeft = true;
                }

                // means that video ended and rewinded
                if (data.status === 'pause' && data.progress === 0) {
                    this.videoState = {};
                }
                break;

            case 'adStateChange':
                if (data.state === 'play') {
                    Metrika.reachGoal('TRAILER_AD_START');

                    if (data.type === 'preroll') {
                        Metrika.reachGoal('TRAILER_AD_START_PREROLL');
                    }
                    if (data.type === 'postroll') {
                        Metrika.reachGoal('TRAILER_AD_START_POSTROLL');
                    }
                } else if (data.state === 'end') {
                    if (data.type === 'preroll') {
                        this._trailerAdDone = true;
                    }
                    Metrika.reachGoal('TRAILER_AD_DONE');
                }

                break;

            case 'stateChange':
                if (data.state === 'play' && this._trailerAdDone) {
                    Metrika.reachGoal('TRAILER_PLAY_AFTER_AD');
                }
                break;
        }
    }
}

Video.defaultProps = {
    onClose: () => {},
    postMessageHandler: () => {},
};

Video.propTypes = {
    title: PropTypes.string,
    src: PropTypes.string.isRequired,
    width: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    height: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    postMessageHandler: PropTypes.func,
    onClose: PropTypes.func,
    metrika: PropTypes.object,
    hasFixedVersion: PropTypes.bool,
    mods: PropTypes.shape({
        fixed: PropTypes.bool,
    }),
    isTrailer: PropTypes.bool,
};

module.exports = withI18n(Video);
